import { render, staticRenderFns } from "./82.vue?vue&type=template&id=a52b7d7c&scoped=true&"
var script = {}
import style0 from "./82.vue?vue&type=style&index=0&id=a52b7d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52b7d7c",
  null
  
)

export default component.exports